import React from 'react';
// nodejs library that concatenates classes
import classNames from 'classnames';
// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Card from 'components/Card/Card.jsx';
import CardAvatar from 'components/Card/CardAvatar.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardFooter from 'components/Card/CardFooter.jsx';
import Button from 'components/CustomButtons/Button.jsx';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import Gallery from '../../../Gallery';

import teamStyle from 'assets/jss/material-kit-pro-react/views/aboutUsSections/teamStyle.jsx';

import FaceIra from 'assets/img/faces/ira_face.jpg';

function SectionTeam(props) {
  const { classes } = props;
  return (
    <div className={classes.team}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(
            classes.mrAuto,
            classes.mlAuto,
            classes.textCenter,
          )}
        >
          <h2 className={classes.title}>“Practice and all is coming.”</h2>
          <h5 className={classes.description}>
            I started to practice yoga around 20 years ago and teach yoga 15
            years ago. 11 years of these years belong to Universal Yoga style. I
            have the highest ERYS 500 and YECEP certificates from American Yoga
            Alliance, Guruji Dev Das Maharaj certificate, Birthlight (Francoise
            Barbira Freedman) School Diploma in Perinatal Yoga (Range Teacher),
            Qigong, Pilates Matwork. I have University Medical degree. I am the
            founder of YA registered "Ekagrata" yoga school in North Miami
            Beach, Florida. I am the a creator of my own programs of Mandala
            yoga, such as "Chacras opening", "Mandala of Wishes", " Energy
            accumulation", " Achievement of emptiness state", etc, which are
            Universal Yoga based. It's my pleasure to share my experience with
            everyone, who is on enlightenment way. Namaste.
          </h5>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem lg={4} md={4} sm={12} xs={12}>
          <Card profile plain>
            <CardAvatar profile plain>
              <a href="#pablo">
                <img src={FaceIra} alt="profile-pic" className={classes.img} />
              </a>
            </CardAvatar>
            <CardBody plain>
              <h4 className={classes.cardTitle}>Erin</h4>
              <h6 className={classes.textMuted}>Your friendly Yoga teacher</h6>
              <p className={classes.cardDescription}>
                It's my pleasure to share my experience with everyone, who is on
                enlightenment way. Namaste.
                <br />
                <strong>786 202 4003 (please text only)</strong>
              </p>
            </CardBody>
            <CardFooter className={classes.justifyContent}>
              <Button
                href="https://www.youtube.com/channel/UCYSuigDznRM0ci5JQ2PVYBg/"
                justIcon
                simple
                color="youtube"
              >
                <i className="fab fa-youtube" />
              </Button>
              <Button
                href="https://www.facebook.com/irina.galka.5"
                justIcon
                simple
                color="facebook"
              >
                <i className="fab fa-facebook" />
              </Button>
              <Button
                href="https://www.instagram.com/erin_yoga_studio/"
                justIcon
                simple
                color="google"
              >
                <i className="fab fa-instagram" />
              </Button>

              <Button
                href="mailto:erinyogastudio@gmail.com"
                justIcon
                simple
                color="google"
              >
                <i className="fas fa-envelope-square" />
              </Button>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem lg={8} md={8} sm={12} xs={12}>
          <Gallery classes={classes} />
        </GridItem>
      </GridContainer>
    </div>
  );
}

export default withStyles(teamStyle)(SectionTeam);



// WEBPACK FOOTER //
// ./src/views/YogaPage/Sections/AboutUsPage/Sections/SectionTeam.jsx